import React from 'react';
import { Box } from '@mui/material';

export type PillTone = 'success' | 'accent' | 'muted' | 'warn' | 'danger' | 'outline';

const TONES: Record<PillTone, { bg: string; fg: string; border?: string }> = {
  success: { bg: 'var(--success-bg)', fg: 'var(--success)' },
  accent: { bg: 'var(--accent-bg)', fg: 'var(--accent-fg)' },
  muted: { bg: 'var(--muted-bg)', fg: 'var(--muted)' },
  warn: { bg: 'var(--warn-bg)', fg: 'var(--warn)' },
  danger: { bg: 'var(--danger-bg)', fg: 'var(--danger)' },
  outline: { bg: 'transparent', fg: 'var(--fg)', border: '1px solid var(--border)' },
};

interface StatusPillProps {
  label: React.ReactNode;
  tone?: PillTone;
  icon?: React.ReactNode;
  // Small leading dot in the current colour, e.g. "● Active · 11 days left".
  dot?: boolean;
}

export const StatusPill = ({ label, tone = 'muted', icon, dot }: StatusPillProps) => {
  const t = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        fontSize: 12,
        fontWeight: 500,
        borderRadius: '6px',
        px: 1,
        py: t.border ? '2px' : '3px',
        display: 'inline-flex',
        gap: 0.75,
        alignItems: 'center',
        whiteSpace: 'nowrap',
        backgroundColor: t.bg,
        color: t.fg,
        border: t.border,
        '& svg': { fontSize: 14 },
      }}
    >
      {dot && <Box component="span" sx={{ width: 6, height: 6, borderRadius: '9px', backgroundColor: 'currentColor' }} />}
      {icon}
      {label}
    </Box>
  );
};
